import styled from 'styled-components'

export const StatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #111111;
    margin-bottom: 64px;
`

export const StatsWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 0 50px;

    @media screen and (max-width: 768px){
        padding: 0 20px;
    }
`

export const StatsCard = styled.div`
    background: #1a1a1a;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: left;
    border-radius: 10px;
    height: 340px;
    width: 400px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;
    overflow: hidden;
    margin-bottom: 32px;

    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        box-shadow: 0px 0px 10px 5px #ff1a1a;
    }
`

export const StatsH1 = styled.h1`
    font-size: 2.5rem;
    color: #fff;
    margin-bottom: 64px;
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 48px;
    }
    
    @media screen and (max-width: 480px){
        font-size: 1.5rem;
        margin-bottom: 36px;
    }
`

export const StatsNumber = styled.h2`
    font-size: 5rem;
    margin-bottom: 10px;
    text-transform: uppercase;
    text-align: center;
    color: #ff1a1a;
    text-shadow: 0 0 10px #ff1a1a;

    @media screen and (max-width: 768px){
        font-size: 4rem;
        margin-bottom: 5px;
    }

    @media screen and (max-width: 480px){
        margin-bottom: 0px;
        font-size: 3rem;
    }
`

export const StatsH2 = styled.h2`
    font-size: 1.75rem;
    margin-bottom: 10px;
    text-transform: uppercase;
    text-align: center;

    @media screen and (max-width: 768px){
        font-size: 1.5rem;
        margin-bottom: 5px;
    }

    @media screen and (max-width: 480px){
        margin-bottom: 0px;
        font-size: 1.25rem;
    }
`

export const StatsP = styled.p`
    font-size: 0.9rem;
    text-align: left;

    @media screen and (max-width: 768px){
        font-size: 0.65rem;
    }

    @media screen and (max-width: 480px){
        font-size: 0.4rem;
    }
`

export const StatsContentWrapper = styled.div`
    color: #fff;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    max-height: 340px;
    width: 100%;
    overflow: hidden;
`

export const StatsContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
`

export const StatsNumberContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
    width: 100%;
`